export const scrollIntoViewRefCallback = (element?: HTMLElement): void => {
    if (element) {
        element.scrollIntoView();
    }
};
